export default class EscapeEventListener {

	constructor() {
		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape") {
				document.dispatchEvent(new CustomEvent("escape.pressed"));
			}
		});
	}
}
